import { createAsyncThunk } from "@reduxjs/toolkit";
import {get_details} from './homepage-service';



export const getHomepageDetailsThunk = createAsyncThunk(
    'get_details',
    async () => await get_details()
)